(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3517],{

/***/ 65700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var LoaderIcon = function(props) {
    var waterSplashLoader = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "waterSplashLoader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var ellipsis = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "ds-ellipsis-loader",
            style: props.style,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            ]
        });
    };
    var _renderLoader = function(type) {
        switch(type){
            case "water_splash_loader":
                return waterSplashLoader();
            case "ellipsis":
            default:
                return ellipsis();
        }
    };
    return _renderLoader(props.type || "");
};
/* harmony default export */ __webpack_exports__["Z"] = (LoaderIcon);


/***/ }),

/***/ 82292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lc": function() { return /* binding */ WIDGET_TYPE; },
/* harmony export */   "an": function() { return /* binding */ CONTAINER_TYPE; },
/* harmony export */   "yP": function() { return /* binding */ LAYOUT_TYPE; }
/* harmony export */ });
var LAYOUT_TYPE = {
    layout1: "layout1",
    layout2: "layout2",
    layout3: "layout3",
    layout4: "layout4",
    layout5: "layout5"
};
var WIDGET_TYPE = {
    INSTAGRAM_POST: "instagramPost",
    COLLECTION: "collection",
    CATEGORY: "category",
    CATEGORIES: "categories",
    FEATURE: "feature",
    FEATURED_COLLECTION: "featuredCollection",
    FEATURED_REELS: "featuredReels",
    TESTIMONIALS: "testimonials",
    LOGO_SLIDER: "logoSlider",
    BLOG: "blog",
    ICON: "icon",
    IMAGE: "image",
    INSTAGRAM: "instagram"
};
var CONTAINER_TYPE = {
    GRID: "grid",
    CAROUSEL: "carousel"
};


/***/ }),

/***/ 99907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useGetIterableItems; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25617);
/* harmony import */ var src_constants_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42381);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68037);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96031);
/* harmony import */ var src_utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13886);









// This adds a collection in the list if a new collection is added by the merchant from web console
function useGetIterableItems(param) {
    var // old list config set from builder
    builderCollections = param.builderCollections, _removeNotVisibleItems = param.removeNotVisibleItems, removeNotVisibleItems = _removeNotVisibleItems === void 0 ? false : _removeNotVisibleItems, _defaultItemVisibility = param.defaultItemVisibility, defaultItemVisibility = _defaultItemVisibility === void 0 ? true : _defaultItemVisibility, _fromBuilderOutline = param.fromBuilderOutline, fromBuilderOutline = _fromBuilderOutline === void 0 ? false : _fromBuilderOutline, _contentType = param.contentType, contentType = _contentType === void 0 ? "collection" : _contentType, _dependency = param.dependency, dependency = _dependency === void 0 ? [] : _dependency;
    var ref, ref1, ref2;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), moreItemsAvailable = ref3[0], setMoreItemsAvailable = ref3[1];
    var listType = {
        tag: (ref = contentType === null || contentType === void 0 ? void 0 : contentType.toLowerCase()) === null || ref === void 0 ? void 0 : ref.includes("tag"),
        collection: (ref1 = contentType === null || contentType === void 0 ? void 0 : contentType.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes("collection"),
        category: (ref2 = contentType === null || contentType === void 0 ? void 0 : contentType.toLowerCase()) === null || ref2 === void 0 ? void 0 : ref2.includes("category"),
        featuredTag: contentType === "featuredTag",
        featuredCollection: contentType === "featuredCollection",
        featuredCategory: contentType === src_constants_widgets__WEBPACK_IMPORTED_MODULE_2__/* .ADMIN_WIDGETS.FEATURED_CATEGORIES.type */ .Pe.FEATURED_CATEGORIES.type
    };
    var ref4 = (0,src_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSSRSelector */ .kF)(function(state) {
        return {
            latestCollectionProducts: state.catalogReducer.collectionCatalogItems,
            storeData: state.storeReducer.store,
            latestCategories: state.catalogReducer.categories,
            latestTags: state.catalogReducer.productTags,
            // Featured collection products
            latestCollections: state.catalogReducer.collections,
            // Featured tags/category products
            latestCategoryProducts: state.catalogReducer.catalog_items
        };
    }), latestCollections = ref4.latestCollections, storeData = ref4.storeData, latestCollectionProducts = ref4.latestCollectionProducts, latestCategories = ref4.latestCategories, latestTags = ref4.latestTags, latestCategoryProducts = ref4.latestCategoryProducts;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), currentChosenCollection = ref5[0], setCurrentChosenCollection = ref5[1];
    var selectedLatestList = function() {
        if (!contentType) return null;
        if (listType.tag) return latestTags;
        if (listType.collection) return latestCollections;
        return latestCategories;
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!fromBuilderOutline && Array.isArray(builderCollections)) {
            if (listType.featuredCollection || listType.featuredTag || listType.featuredCategory) {
                var shownItem = builderCollections === null || builderCollections === void 0 ? void 0 : builderCollections.find(function(item) {
                    return item === null || item === void 0 ? void 0 : item.isVisible;
                });
                if (!shownItem) {
                    return;
                }
                var list = listType.featuredCollection ? latestCollections : listType.featuredCategory ? latestCategories : latestTags;
                var storeCollection = list === null || list === void 0 ? void 0 : list.find(function(listItem) {
                    return listItem.id === shownItem.id;
                });
                setCurrentChosenCollection(storeCollection);
                // Don't make API calls if data already present in reducer
                var isProductListAlreadyPresent = function() {
                    if (listType.featuredCollection) {
                        return latestCollectionProducts === null || latestCollectionProducts === void 0 ? void 0 : latestCollectionProducts[storeCollection === null || storeCollection === void 0 ? void 0 : storeCollection.id];
                    }
                    return latestCategoryProducts === null || latestCategoryProducts === void 0 ? void 0 : latestCategoryProducts[storeCollection === null || storeCollection === void 0 ? void 0 : storeCollection.id];
                }();
                if (!storeCollection || storeCollection && isProductListAlreadyPresent) {
                    return;
                }
                var dispatchCalls = [];
                if (listType.featuredCollection) {
                    var ref;
                    storeCollection === null || storeCollection === void 0 ? void 0 : (ref = storeCollection.categories) === null || ref === void 0 ? void 0 : ref.forEach(function(category) {
                        dispatchCalls.push((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .fetchCollectionCatalogItemById */ .lA)({
                            storeId: storeData.store_id,
                            collectionId: storeCollection.id,
                            categoryId: category.id
                        }));
                    });
                    (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .batch */ .dC)(function() {
                        dispatchCalls.map(function(apiCall) {
                            return dispatch(apiCall);
                        });
                    });
                }
                if (listType.featuredTag) {
                    var payload = {
                        store_id: storeData.store_id,
                        category_id: storeCollection.id,
                        category_type: src_utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .CATEGORY_TYPE.TAG */ .MI.TAG,
                        page_no: 0
                    };
                    dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .fetchCatalogItemsByCategoryId */ .Is)(payload));
                }
                if (listType.featuredCategory) {
                    var payload1 = {
                        store_id: storeData.store_id,
                        category_id: storeCollection.id,
                        category_type: src_utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .CATEGORY_TYPE.CATEGORY */ .MI.CATEGORY,
                        page_no: 0
                    };
                    dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_5__/* .fetchCatalogItemsByCategoryId */ .Is)(payload1));
                }
            }
        }
    }, [
        builderCollections, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(listType.featuredCollection ? [
        latestCollections,
        latestCollectionProducts
    ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(listType.featuredTag ? [
        latestTags,
        latestCategoryProducts
    ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(listType.featuredCategory ? [
        latestCategories,
        latestCategoryProducts
    ] : [])));
    var iterableList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var list = [];
        var newAddedItems = [];
        if (!(Array.isArray(builderCollections) || (selectedLatestList === null || selectedLatestList === void 0 ? void 0 : selectedLatestList.length))) {
            return list;
        }
        // For CFE: For product items in a collection/tag/category
        if (!fromBuilderOutline && (listType.featuredCollection || listType.featuredTag || listType.featuredCategory)) {
            var productList = listType.featuredCollection ? latestCollectionProducts : latestCategoryProducts;
            if (productList === null || productList === void 0 ? void 0 : productList[currentChosenCollection === null || currentChosenCollection === void 0 ? void 0 : currentChosenCollection.id]) {
                var interList = [];
                var items = function() {
                    if (Array.isArray(productList[currentChosenCollection.id])) return productList[currentChosenCollection.id];
                    return Object.values(productList[currentChosenCollection.id]);
                }();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Fill interlist with products to be pushed
                    for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var item = _step.value;
                        var _interList;
                        if ((interList === null || interList === void 0 ? void 0 : interList.length) >= 13) {
                            !moreItemsAvailable && setMoreItemsAvailable(true);
                            break;
                        } else !Array.isArray(item) ? interList.push(item) : (_interList = interList).push.apply(_interList, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(item || []));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (interList === null || interList === void 0 ? void 0 : interList.length) {
                    var _list;
                    (_list = list).push.apply(_list, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(interList.map(function(productItem) {
                        return {
                            data: productItem,
                            isVisible: true,
                            id: productItem === null || productItem === void 0 ? void 0 : productItem.id,
                            type: "product"
                        };
                    })));
                }
            }
        } else {
            // For collection, categories, tags list
            selectedLatestList.forEach(function(latestListItem) {
                var builderRefItemIndex = builderCollections === null || builderCollections === void 0 ? void 0 : builderCollections.findIndex(function(builderItem) {
                    return (builderItem === null || builderItem === void 0 ? void 0 : builderItem.id) === latestListItem.id;
                });
                var builderItem = (builderCollections === null || builderCollections === void 0 ? void 0 : builderCollections[builderRefItemIndex]) || {};
                var isLatestListItemAlreadyPresent = builderRefItemIndex > -1;
                // Is latest item from backend present in build list, update the data
                if (isLatestListItemAlreadyPresent) {
                    var ref;
                    list[builderRefItemIndex] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, builderItem), {
                        itemCount: latestListItem === null || latestListItem === void 0 ? void 0 : (ref = latestListItem.categories) === null || ref === void 0 ? void 0 : ref.length,
                        data: latestListItem,
                        type: contentType
                    });
                } else {
                    var ref1;
                    newAddedItems.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, builderItem), {
                        id: latestListItem.id,
                        rank: latestListItem.rank || 0,
                        isVisible: defaultItemVisibility,
                        itemCount: latestListItem === null || latestListItem === void 0 ? void 0 : (ref1 = latestListItem.categories) === null || ref1 === void 0 ? void 0 : ref1.length,
                        data: latestListItem,
                        type: contentType
                    }));
                }
            });
        }
        var finalList = list === null || list === void 0 ? void 0 : list.concat(newAddedItems);
        if (removeNotVisibleItems) {
            finalList = finalList === null || finalList === void 0 ? void 0 : finalList.filter(function(item) {
                return item && item.isVisible;
            });
        }
        return finalList;
    }, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(dependency).concat([
        selectedLatestList, 
    ], (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(listType.featuredCollection ? [
        latestCollectionProducts,
        currentChosenCollection
    ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(listType.featuredTag || listType.featuredCategory ? [
        currentChosenCollection,
        latestCategoryProducts
    ] : [])));
    return {
        iterableList: iterableList,
        moreItemsAvailable: moreItemsAvailable
    };
}


/***/ }),

/***/ 79220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ GlobalCfeLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _globalLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25480);


var GlobalCfeLoader = function(param) {
    var type = param.type, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_globalLoader__WEBPACK_IMPORTED_MODULE_1__/* .GlobalLoader */ .k, {
        type: type,
        color: color
    });
};


/***/ }),

/***/ 25480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ GlobalLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85134);
/* harmony import */ var _globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98388);
/* harmony import */ var src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26706);
/* harmony import */ var src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65700);







var GlobalLoader = function(props) {
    var type = props.type, color = props.color;
    var store = (0,src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.documentElement.style.setProperty("--loader-color", color);
    }, [
        color
    ]);
    switch(type){
        case "logo1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo1)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "logo2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo2)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: store.logo_image,
                        style: {
                            height: "35px",
                            width: "35px"
                        }
                    })
                });
            }
        case "loader1":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    version: "1.1",
                    id: "L9",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "65px",
                    height: "65px",
                    viewBox: "0 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: color,
                        d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            dur: "1s",
                            from: "0 50 50",
                            to: "360 50 50",
                            repeatCount: "indefinite"
                        })
                    })
                });
            }
        case "loader2":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L5",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 15 ; 0 -15; 0 15",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "30",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 10 ; 0 -10; 0 10",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "54",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader3":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader3), "tw-h-[35px] tw-w-[35px]")
                });
            }
        case "loader4":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    version: "1.1",
                    id: "L4",
                    xmlns: "http://www.w3.org/2000/svg",
                    x: "0px",
                    y: "0px",
                    width: "35px",
                    height: "35px",
                    viewBox: "-20 0 100 100",
                    enableBackground: "new 0 0 0 0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "6",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "26",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            fill: color,
                            stroke: "none",
                            cx: "46",
                            cy: "50",
                            r: "6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animate", {
                                attributeName: "opacity",
                                dur: "1s",
                                values: "0;1;0",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        })
                    ]
                });
            }
        case "loader5":
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m6)((_globalLoader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().loader5), "tw-h-[16px] tw-w-[35px]")
                });
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Common_LoaderIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
            }
    }
};


/***/ }),

/***/ 85134:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo1":"globalLoader_logo1__U4pxQ","logo-1":"globalLoader_logo-1__07zYZ","logo2":"globalLoader_logo2__eivVl","loader-3":"globalLoader_loader-3__8hklP","loader3":"globalLoader_loader3__m47Bj","loader5":"globalLoader_loader5__6NXRf","loader-5-1":"globalLoader_loader-5-1__pESNT","loader-5-2":"globalLoader_loader-5-2__VgxuZ"};

/***/ })

}]);